var map = {
	"./Pages/Blocks.vue": "./resources/js/Pages/Blocks.vue",
	"./Pages/Blocks2.vue": "./resources/js/Pages/Blocks2.vue",
	"./components/AccountAnalytics.vue": "./resources/js/components/AccountAnalytics.vue",
	"./components/AlamedaUnlocks.vue": "./resources/js/components/AlamedaUnlocks.vue",
	"./components/AnalyticsHeroStat.vue": "./resources/js/components/AnalyticsHeroStat.vue",
	"./components/AnalyticsOverview.vue": "./resources/js/components/AnalyticsOverview.vue",
	"./components/AssetTokenInfo.vue": "./resources/js/components/AssetTokenInfo.vue",
	"./components/AutocompleteSearch.vue": "./resources/js/components/AutocompleteSearch.vue",
	"./components/BlockExplorer.vue": "./resources/js/components/BlockExplorer.vue",
	"./components/BlockMetricsChart.vue": "./resources/js/components/BlockMetricsChart.vue",
	"./components/BlockTimeDashboard.vue": "./resources/js/components/BlockTimeDashboard.vue",
	"./components/BlockTimeSeriesChart.vue": "./resources/js/components/BlockTimeSeriesChart.vue",
	"./components/BookmarkButton.vue": "./resources/js/components/BookmarkButton.vue",
	"./components/BuySellPressure.vue": "./resources/js/components/BuySellPressure.vue",
	"./components/CommentForm.vue": "./resources/js/components/CommentForm.vue",
	"./components/CommissionBarChart.vue": "./resources/js/components/CommissionBarChart.vue",
	"./components/CommissionChangeTimeline.vue": "./resources/js/components/CommissionChangeTimeline.vue",
	"./components/CommissionWeightedChart.vue": "./resources/js/components/CommissionWeightedChart.vue",
	"./components/ConstellationCalculator.vue": "./resources/js/components/ConstellationCalculator.vue",
	"./components/CurrencyToggle.vue": "./resources/js/components/CurrencyToggle.vue",
	"./components/DateRangePicker.vue": "./resources/js/components/DateRangePicker.vue",
	"./components/DefiAnalytics.vue": "./resources/js/components/DefiAnalytics.vue",
	"./components/Delegate.vue": "./resources/js/components/Delegate.vue",
	"./components/DexDetail.vue": "./resources/js/components/DexDetail.vue",
	"./components/EpochTime.vue": "./resources/js/components/EpochTime.vue",
	"./components/EthStake.vue": "./resources/js/components/EthStake.vue",
	"./components/ExampleComponent.vue": "./resources/js/components/ExampleComponent.vue",
	"./components/FeeAnalytics.vue": "./resources/js/components/FeeAnalytics.vue",
	"./components/FeeBurn.vue": "./resources/js/components/FeeBurn.vue",
	"./components/FlowChart.vue": "./resources/js/components/FlowChart.vue",
	"./components/FollowButton.vue": "./resources/js/components/FollowButton.vue",
	"./components/GradientChart.vue": "./resources/js/components/GradientChart.vue",
	"./components/GranularityToggle.vue": "./resources/js/components/GranularityToggle.vue",
	"./components/HolderAnalytics.vue": "./resources/js/components/HolderAnalytics.vue",
	"./components/HolderAnalyticsCharts.vue": "./resources/js/components/HolderAnalyticsCharts.vue",
	"./components/IdleMiner.vue": "./resources/js/components/IdleMiner.vue",
	"./components/JupiterSwap.vue": "./resources/js/components/JupiterSwap.vue",
	"./components/LeafletMap.vue": "./resources/js/components/LeafletMap.vue",
	"./components/LiveFeed.vue": "./resources/js/components/LiveFeed.vue",
	"./components/LivePrice.vue": "./resources/js/components/LivePrice.vue",
	"./components/LiveTicker.vue": "./resources/js/components/LiveTicker.vue",
	"./components/MarinadeForm.vue": "./resources/js/components/MarinadeForm.vue",
	"./components/MetricCard.vue": "./resources/js/components/MetricCard.vue",
	"./components/MevRewardsClaimer.vue": "./resources/js/components/MevRewardsClaimer.vue",
	"./components/NavigatorCallout.vue": "./resources/js/components/NavigatorCallout.vue",
	"./components/NavigatorChart.vue": "./resources/js/components/NavigatorChart.vue",
	"./components/NavigatorChat.vue": "./resources/js/components/NavigatorChat.vue",
	"./components/NavigatorDataTable.vue": "./resources/js/components/NavigatorDataTable.vue",
	"./components/NavigatorMetricCards.vue": "./resources/js/components/NavigatorMetricCards.vue",
	"./components/NavigatorSuggestions.vue": "./resources/js/components/NavigatorSuggestions.vue",
	"./components/NavigatorTokenBadge.vue": "./resources/js/components/NavigatorTokenBadge.vue",
	"./components/NetFlowChart.vue": "./resources/js/components/NetFlowChart.vue",
	"./components/NetworkAnalytics.vue": "./resources/js/components/NetworkAnalytics.vue",
	"./components/NetworkStatus.vue": "./resources/js/components/NetworkStatus.vue",
	"./components/OrganicScoreGauge.vue": "./resources/js/components/OrganicScoreGauge.vue",
	"./components/PageForm.vue": "./resources/js/components/PageForm.vue",
	"./components/PaginationControls.vue": "./resources/js/components/PaginationControls.vue",
	"./components/PoolDetail.vue": "./resources/js/components/PoolDetail.vue",
	"./components/PostForm.vue": "./resources/js/components/PostForm.vue",
	"./components/PriceChangeTabs.vue": "./resources/js/components/PriceChangeTabs.vue",
	"./components/ProModeToggle.vue": "./resources/js/components/ProModeToggle.vue",
	"./components/ProgramAnalytics.vue": "./resources/js/components/ProgramAnalytics.vue",
	"./components/ProgramDetail.vue": "./resources/js/components/ProgramDetail.vue",
	"./components/ProjectForm.vue": "./resources/js/components/ProjectForm.vue",
	"./components/ProjectVoteModal.vue": "./resources/js/components/ProjectVoteModal.vue",
	"./components/ProjectVoteScore.vue": "./resources/js/components/ProjectVoteScore.vue",
	"./components/ProjectVoting.vue": "./resources/js/components/ProjectVoting.vue",
	"./components/RestartStatus.vue": "./resources/js/components/RestartStatus.vue",
	"./components/RewardCalculator.vue": "./resources/js/components/RewardCalculator.vue",
	"./components/RichTextEditor.vue": "./resources/js/components/RichTextEditor.vue",
	"./components/SolendLoop.vue": "./resources/js/components/SolendLoop.vue",
	"./components/SparklineChart.vue": "./resources/js/components/SparklineChart.vue",
	"./components/StakeAccount.vue": "./resources/js/components/StakeAccount.vue",
	"./components/StakeAccountMovements.vue": "./resources/js/components/StakeAccountMovements.vue",
	"./components/StakeDashboard.vue": "./resources/js/components/StakeDashboard.vue",
	"./components/StakeDistribution.vue": "./resources/js/components/StakeDistribution.vue",
	"./components/StakeEconomy.vue": "./resources/js/components/StakeEconomy.vue",
	"./components/StakeHealth.vue": "./resources/js/components/StakeHealth.vue",
	"./components/StakeLST.vue": "./resources/js/components/StakeLST.vue",
	"./components/StakePoolDetails.vue": "./resources/js/components/StakePoolDetails.vue",
	"./components/StakingAnalytics.vue": "./resources/js/components/StakingAnalytics.vue",
	"./components/StakingFlows.vue": "./resources/js/components/StakingFlows.vue",
	"./components/StakingHealthcheck.vue": "./resources/js/components/StakingHealthcheck.vue",
	"./components/Swap.vue": "./resources/js/components/Swap.vue",
	"./components/SwapInner.vue": "./resources/js/components/SwapInner.vue",
	"./components/SwapWidget.vue": "./resources/js/components/SwapWidget.vue",
	"./components/TokenChart.vue": "./resources/js/components/TokenChart.vue",
	"./components/TokenComparison.vue": "./resources/js/components/TokenComparison.vue",
	"./components/TokenDetailTabs.vue": "./resources/js/components/TokenDetailTabs.vue",
	"./components/TokenExplorer.vue": "./resources/js/components/TokenExplorer.vue",
	"./components/TokenHeader.vue": "./resources/js/components/TokenHeader.vue",
	"./components/TokenList.vue": "./resources/js/components/TokenList.vue",
	"./components/TokenMarkets.vue": "./resources/js/components/TokenMarkets.vue",
	"./components/TokenNewsFeed.vue": "./resources/js/components/TokenNewsFeed.vue",
	"./components/TokenPriceChart.vue": "./resources/js/components/TokenPriceChart.vue",
	"./components/TokenSearch.vue": "./resources/js/components/TokenSearch.vue",
	"./components/TokenSecurityPanel.vue": "./resources/js/components/TokenSecurityPanel.vue",
	"./components/TokenSelector.vue": "./resources/js/components/TokenSelector.vue",
	"./components/TokenSelectorModal.vue": "./resources/js/components/TokenSelectorModal.vue",
	"./components/TokenStats.vue": "./resources/js/components/TokenStats.vue",
	"./components/TokenSupplyEvents.vue": "./resources/js/components/TokenSupplyEvents.vue",
	"./components/TokenTableUpdater.vue": "./resources/js/components/TokenTableUpdater.vue",
	"./components/TokenTechnicalAnalysis.vue": "./resources/js/components/TokenTechnicalAnalysis.vue",
	"./components/TokenTrades.vue": "./resources/js/components/TokenTrades.vue",
	"./components/TokenWidget.vue": "./resources/js/components/TokenWidget.vue",
	"./components/TransferAnalytics.vue": "./resources/js/components/TransferAnalytics.vue",
	"./components/TreeMap.vue": "./resources/js/components/TreeMap.vue",
	"./components/TurboStake.vue": "./resources/js/components/TurboStake.vue",
	"./components/ValidatorDefiLeaderboard.vue": "./resources/js/components/ValidatorDefiLeaderboard.vue",
	"./components/ValidatorDefiMetrics.vue": "./resources/js/components/ValidatorDefiMetrics.vue",
	"./components/ValidatorDetail.vue": "./resources/js/components/ValidatorDetail.vue",
	"./components/ValidatorPerformanceChart.vue": "./resources/js/components/ValidatorPerformanceChart.vue",
	"./components/ValidatorStakeChanges.vue": "./resources/js/components/ValidatorStakeChanges.vue",
	"./components/Validators/ValidatorScore.vue": "./resources/js/components/Validators/ValidatorScore.vue",
	"./components/Validators/ValidatorsTable.vue": "./resources/js/components/Validators/ValidatorsTable.vue",
	"./components/VoteButtons.vue": "./resources/js/components/VoteButtons.vue",
	"./components/WalletActivity.vue": "./resources/js/components/WalletActivity.vue",
	"./components/WalletButton.vue": "./resources/js/components/WalletButton.vue",
	"./components/WalletConnection.vue": "./resources/js/components/WalletConnection.vue",
	"./components/WalletExplorer.vue": "./resources/js/components/WalletExplorer.vue",
	"./components/WalletHoldings.vue": "./resources/js/components/WalletHoldings.vue",
	"./components/WalletTrades.vue": "./resources/js/components/WalletTrades.vue",
	"./components/WalletTransfers.vue": "./resources/js/components/WalletTransfers.vue",
	"./components/WhaleTracker.vue": "./resources/js/components/WhaleTracker.vue",
	"./components/analytics/BlockAnalytics.vue": "./resources/js/components/analytics/BlockAnalytics.vue",
	"./components/analytics/NetworkOverview.vue": "./resources/js/components/analytics/NetworkOverview.vue",
	"./components/analytics/ProgramComplexity.vue": "./resources/js/components/analytics/ProgramComplexity.vue",
	"./components/analytics/ProgramComputeMetrics.vue": "./resources/js/components/analytics/ProgramComputeMetrics.vue",
	"./components/analytics/ProgramDefiActivity.vue": "./resources/js/components/analytics/ProgramDefiActivity.vue",
	"./components/analytics/ProgramFeeEconomics.vue": "./resources/js/components/analytics/ProgramFeeEconomics.vue",
	"./components/analytics/ProgramTable.vue": "./resources/js/components/analytics/ProgramTable.vue",
	"./components/analytics/ProgramTransactionActivity.vue": "./resources/js/components/analytics/ProgramTransactionActivity.vue",
	"./components/analytics/ProgramUserActivity.vue": "./resources/js/components/analytics/ProgramUserActivity.vue",
	"./components/defi/BorrowLend.vue": "./resources/js/components/defi/BorrowLend.vue",
	"./components/defi/LiquidityPools.vue": "./resources/js/components/defi/LiquidityPools.vue",
	"./components/tvChart.vue": "./resources/js/components/tvChart.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./resources/js sync recursive \\.vue$/";